import React from 'react';
import { PlusIcon, FlagIcon } from 'lucide-react';
import { BudgetLineItem as BudgetLineItemType, Condition } from '../types/budget';
interface BudgetLineItemProps {
  item: BudgetLineItemType;
  condition?: Condition;
  onAddCondition: () => void;
  onEditCondition: () => void;
}
export function BudgetLineItem({
  item,
  condition,
  onAddCondition,
  onEditCondition
}: BudgetLineItemProps) {
  const isZeroBudget = item.budgetAmount === 0;
  const formatCurrency = (value: number) => new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
  const formatPercent = (value: number) => new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  }).format(value) + '%';
  return <tr className={`group hover:bg-blue-50/30 transition-colors ${isZeroBudget ? 'text-gray-400' : 'text-primary'}`} data-id="element-13">
      <td className={`border border-gray-300 px-2 py-1 relative ${condition ? 'border-l-2 border-l-accent-1' : ''}`} data-id="element-14">
        <div className="flex items-center justify-between" data-id="element-15">
          <span className={`text-xs font-body pl-2 ${condition ? 'font-medium' : 'font-normal'}`} data-id="element-16">
            {item.name}
          </span>

          <div className="flex items-center" data-id="element-17">
            {condition ? <button onClick={onEditCondition} className="flex items-center gap-1 px-1.5 py-0.5 rounded bg-accent-1/20 text-yellow-800 text-[10px] border border-accent-1/30 hover:bg-accent-1/30 transition-colors" title="View Modification Request" data-id="element-18">
                <FlagIcon className="w-3 h-3" data-id="element-19" />
                <span data-id="element-20">Mod Request</span>
              </button> : <button onClick={onAddCondition} className="hidden group-hover:flex items-center gap-1 px-1.5 py-0.5 rounded bg-accent/10 text-accent text-[10px] hover:bg-accent/20 transition-colors" data-id="element-21">
                <PlusIcon className="w-3 h-3" data-id="element-22" />
                <span data-id="element-23">Add Mod</span>
              </button>}
          </div>
        </div>
      </td>

      <td className="border border-gray-300 px-2 py-1 text-right text-xs font-body tabular-nums" data-id="element-24">
        {formatPercent(item.percentOfBudget)}
      </td>

      <td className="border border-gray-300 px-2 py-1 text-right text-xs font-body tabular-nums" data-id="element-25">
        {item.costPerSqFt > 0 ? formatCurrency(item.costPerSqFt) : '-'}
      </td>

      <td className="border border-gray-300 px-2 py-1 text-right text-xs font-body font-medium tabular-nums" data-id="element-26">
        {item.budgetAmount > 0 ? formatCurrency(item.budgetAmount) : '-'}
      </td>

      <td className="border border-gray-300 px-2 py-1 text-center text-xs font-body bg-gray-50/50" data-id="element-27">
        {/* Reallocation Request column - empty for now */}
      </td>
    </tr>;
}